import { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AnimatePresence } from "framer-motion";
import { useDarkModeStore } from "../stores/darkModeStore";
import { useToastStore } from "../stores/toastStore";
import { setLanguage } from "../i18n";
import Toast from "../components/Toast";

export default function Layout() {
  const { isDark, toggle: toggleDark } = useDarkModeStore();

  // 키보드 단축키: / → 검색 포커스
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "/" && !["INPUT", "TEXTAREA", "SELECT"].includes((e.target as HTMLElement).tagName)) {
        e.preventDefault();
        const input = document.querySelector<HTMLInputElement>("input[type='text']");
        input?.focus();
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);
  const { toasts, removeToast } = useToastStore();
  const { t, i18n } = useTranslation();

  const toggleLang = () => {
    setLanguage(i18n.language === "ko" ? "en" : "ko");
  };

  return (
    <>
      <Toast toasts={toasts} onRemove={removeToast} />

      <nav className="bg-zinc-950 py-5 px-10 max-md:py-4 max-md:px-5">
        <div className="max-w-[1100px] mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 no-underline">
            <span className="bg-white text-zinc-950 font-extrabold text-sm px-2.5 py-1.5 rounded-lg tracking-wider">FIN</span>
            <span className="text-white font-semibold text-base">Score</span>
          </Link>
          <div className="flex items-center gap-1">
            <Link to="/screen" className="px-3 py-1.5 rounded-lg text-sm font-semibold text-zinc-400 hover:text-white hover:bg-white/10 transition-colors no-underline">
              탐색
            </Link>
            <button
              onClick={toggleLang}
              className="px-3 py-2 rounded-lg text-xs font-semibold text-zinc-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"
              title={t("common.language")}
            >
              {i18n.language === "ko" ? "EN" : "KO"}
            </button>
            <button onClick={toggleDark} className="p-2 rounded-lg hover:bg-white/10 transition-colors cursor-pointer" title={isDark ? t("common.lightMode") : t("common.darkMode")}>
              {isDark ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
              )}
            </button>
          </div>
        </div>
      </nav>

      <AnimatePresence mode="wait">
        <Outlet />
      </AnimatePresence>

      <footer className="text-center py-10 px-5 text-zinc-400 dark:text-zinc-500 text-[13px] leading-relaxed">
        <p>{t("footer.disclaimer")}</p>
        <p className="mt-2 font-semibold text-zinc-500 dark:text-zinc-400">핀스코어(FINScore)</p>
      </footer>
    </>
  );
}
